/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-template */
import moment from 'moment';
import dayjs from 'dayjs';

export const isDateValid = (date, format = 'YYYY-MM-DD') => {
    const year = moment(date, format).year();
    if (year < 1000 || year > 9999) return false;
    // const month = moment(date, format).month();
    // if (month < 0 || month > 11) return false;
    // const day = moment(date, format).date();
    // if (day < 1 || day > 31) return false;

    if (date) {
        return moment(date, format).isValid();
    }
    return false;
};

export const isTodayOrPastDate = (date) => {
    if (!date) return false;

    const parsedDate = moment(new Date(date));
    return parsedDate.isValid() && parsedDate.isSameOrBefore(moment(), 'day');
};

export const isFutureScheduledSessionDate = (date) => {
    if (!date) return false;

    const parsedDate = moment.utc(date).local();
    return parsedDate.isValid() && parsedDate.isAfter(moment(), 'day');
};

export const isValidDate = (date) => {
    const parsed = dayjs(date, 'YYYY-MM-DD', true);
    if (!parsed.isValid()) return false;

    const year = parsed.year();
    return year >= 1000 && year <= 9999;
};

/**
 * Validates if the string input is a valid positive number with optional decimals.
 * @param {string} value The input value
 * @param {number} maxDecimal Maximum allowed decimal places
 * @returns {boolean}
 */
export const validateNumericInput = (value, maxDecimal = 2) => {
    // Allows empty string for clearing input
    if (value === '') return true;

    // 1. No alphabets or special characters (except one dot)
    // 2. No negative sign
    // 3. Max decimal places
    const regex = new RegExp(`^\\d{0,7}(\\.\\d{0,${maxDecimal}})?$`);

    if (!regex.test(value)) return false;

    return true;
};

export const validateNumericAmountInput = (value, maxDecimal = 2) => {
    if (value === '') return true;
    const regex = new RegExp(`^\\d{0,8}(\\.\\d{0,${maxDecimal}})?$`);

    if (!regex.test(value)) return false;

    return true;
};

/**
 * Formats a numeric value to a fixed number of decimal places.
 * @param {string|number} value
 * @param {number} decimalPlaces
 * @returns {string}
 */
export const formatNumericValue = (value, decimalPlaces = 2) => {
    const num = parseFloat(value);
    if (isNaN(num)) {
        if (decimalPlaces === 0) return '0';
        return '0.' + '0'.repeat(decimalPlaces);
    }
    if (decimalPlaces === 0) return Math.floor(num).toString();
    return num.toFixed(decimalPlaces);
};
